export const PulseItem = () => {
  return (
    <div className="flex gap-4">
      <div className="h-8 w-8 bg-mid-grey-20 rounded-full"></div>
      <div className="h-8 min-w-96 bg-mid-grey-20 rounded-lg"></div>
    </div>
  );
};
